import { HourglassEmpty } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import moment from 'moment';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Moment from 'react-moment';

import { AsyncContent } from '~/components/AsyncContent';
import { NullableTooltip } from '~/components/NullableTooltip';

import { useSxStyles } from './useStyles';
import { useWorktimeSignInOut } from './useWorktimeSignInOut';

export const WorktimeSignInOut: React.FC = () => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  const {
    loading,
    failedToLoad,
    requiresToBeConfigured,
    runningTimeBlock,
    momentIsFilled,
    timerJustStarted,
    startingTimer,
    handleStartTimer,
    stoppingTimer,
    handleStopTimer,
    addedTime,
    handleAddFullDay,
    addedFullDay,
  } = useWorktimeSignInOut();

  const renderActionBtn = (
    color: 'primary' | 'secondary' | 'success',
    translationKey: string,
    disabled?: boolean,
    hasSpacing?: boolean,
    onClick?: () => void,
  ) => (
    <Button
      variant="contained"
      color={color}
      disabled={disabled}
      onClick={onClick}
      fullWidth={true}
      sx={{
        ml: hasSpacing ? 1 : 0,
      }}
    >
      <Typography
        component="strong"
        variant="body2"
        textAlign="center"
        lineHeight={1}
        fontSize={12}
      >
        {t(translationKey)}
      </Typography>
    </Button>
  );

  return (
    <AsyncContent
      isLoading={loading}
      failedToLoad={failedToLoad}
      spinnerSize={20}
      customSxStyles={{
        root: sxStyles.root,
        spinner: sxStyles.spinner,
      }}
    >
      {(runningTimeBlock && (
        <>
          <Box sx={sxStyles.signOutContainer} data-cy="sign-out-container">
            {renderActionBtn(
              'secondary',
              'stopWorktime',
              timerJustStarted || stoppingTimer,
              false,
              handleStopTimer,
            )}
            {renderActionBtn('primary', 'addFullDayAtOnce', true, true)}
          </Box>
          <Box sx={sxStyles.currentSessionDuration}>
            <HourglassEmpty />
            <Moment durationFromNow format="hh:mm:ss" interval={1000}>
              {moment(runningTimeBlock.from, 'hh:mm:ss').toISOString()}
            </Moment>
          </Box>
        </>
      )) || (
        <Box sx={sxStyles.signInContainer} data-cy="sign-in-container">
          <NullableTooltip
            title={
              requiresToBeConfigured
                ? t<string>('defaultWorkReportingTypeIsNotConfigured')
                : momentIsFilled
                ? t<string>('momentIsFilled')
                : ''
            }
          >
            <Box sx={sxStyles.tooltipContainer}>
              {renderActionBtn(
                'success',
                'startWorktime',
                requiresToBeConfigured ||
                  momentIsFilled ||
                  startingTimer ||
                  addedFullDay,
                false,
                handleStartTimer,
              )}
              {renderActionBtn(
                'primary',
                'addFullDayAtOnce',
                requiresToBeConfigured ||
                  timerJustStarted ||
                  stoppingTimer ||
                  addedTime,
                true,
                handleAddFullDay,
              )}
            </Box>
          </NullableTooltip>
        </Box>
      )}
    </AsyncContent>
  );
};
